import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import {commonPropTypes} from "./dependent-entities-selector";
import { injectIntl} from "react-intl";
import {getScoreboardTypesService} from "../../services/commonService";
import MenuItem from "@material-ui/core/MenuItem";
import Select from "@material-ui/core/Select";
import InputLabel from "@material-ui/core/InputLabel";
import FormControl from "@material-ui/core/FormControl";
import {
  SCOREBOARD_TYPE_AUTOMATIC,
  SCOREBOARD_TYPE_AUTOMATIC_BURNT, SCOREBOARD_TYPE_NO_SCOREBOARD
} from "../../pages/event/forms/common-forms/sport-form-constants";

const hasOnlyNoScoreboardType = types =>
    types?.scoreboard_type?.length === 1 && types?.scoreboard_type[0] === SCOREBOARD_TYPE_NO_SCOREBOARD;

const ScoreboardTypeApiSelect = ({
  contractId,
  eventTypeId,
  roomTemplateId,
  register,
  label,
  selectedElement,
  classes,
  intl,
  setHasOnlyNoScoreboard,
  setHasOnlyAutomaticBurnt,
  onChange
}) => {
  const [scoreboardTypes, setScoreboardTypes] = useState([]);

  const scoreboardTypesCallback = (data) => {
    const filteredScoreboardTypes = data.map(item => item.startsWith(SCOREBOARD_TYPE_AUTOMATIC) ? SCOREBOARD_TYPE_AUTOMATIC : item)
        .filter((item, index, self) => self.indexOf(item) === index);

    setScoreboardTypes(filteredScoreboardTypes);

    setHasOnlyNoScoreboard(hasOnlyNoScoreboardType(data));
    const automaticTypes = data.filter(type => type === SCOREBOARD_TYPE_AUTOMATIC);
    setHasOnlyAutomaticBurnt(automaticTypes?.length === 1 && automaticTypes[0] === SCOREBOARD_TYPE_AUTOMATIC_BURNT);
  }

  const getScoreboardTypes = () => {
    getScoreboardTypesService(contractId, eventTypeId, roomTemplateId, scoreboardTypesCallback);
  };

  useEffect(() => {
    if (contractId && eventTypeId && roomTemplateId) {
      getScoreboardTypes();
    }
  }, [contractId, eventTypeId, roomTemplateId]);

  const handleChange = (event) => {
    const value = event.target.value;
    if (onChange) {
      onChange(value);
    }
  };

  return (
      <FormControl className={classes.fullWidth}>
        <InputLabel id="room-template-select-label">{label}</InputLabel>
        <Select
            {...register("sportEventData.scoreboardType")}
            id="sportEventData.scoreboardType"
            defaultValue={selectedElement}
            onChange={handleChange}>
          {scoreboardTypes.map((scoreboard) => (
              <MenuItem key={scoreboard} value={scoreboard}>
                {intl.formatMessage({id: `event.scoreboardType.in.${scoreboard}`})}
              </MenuItem>))}
        </Select>
      </FormControl>
  );
};

ScoreboardTypeApiSelect.propTypes = {
  ...commonPropTypes,
  /**
   * Valor del selector
   */
  selectedElement: PropTypes.oneOfType([PropTypes.string, PropTypes.array]),
  /**
   * Valor del selector
   */
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.array]),
  /**
   * Contrato para el que se mostrarán los templates
   */
  contractId: PropTypes.string,
  /**
   * Tipo de evento para el que se mostrarán los marcadores
   */
  eventTypeId: PropTypes.string,
  /**
   * Plantilla de sala (room template); obligatoria para obtener los marcadores disponibles
   */
  roomTemplateId: PropTypes.string.isRequired,
  /**
   * Callback que se llama al hacer clic sobre el selector
   */
  onClick: PropTypes.func,
  /**
   * Callback que se llama al cambiar el valor del selector
   */
  onChange: PropTypes.func,
};

export default injectIntl(ScoreboardTypeApiSelect);
